import { useEffect, useState } from 'react';
// @mui
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';
import Portal from '@mui/material/Portal';
import Link, { LinkProps } from '@mui/material/Link';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// routes
import { usePathname } from 'src/routes/hook';
import { useActiveLink } from 'src/routes/hook/use-active-link';
//
import { Menu, MenuItem } from '@mui/material';
import { NavItemProps } from '../types';
import { NavItem } from './nav-item';
import { StyledSubheader, StyledMenu } from './styles';

// ----------------------------------------------------------------------

type NavListProps = {
  item: NavItemProps;
  offsetTop: boolean;
};

export default function NavList({ item, offsetTop }: NavListProps) {
  const pathname = usePathname();

  const nav = useBoolean();

  const { path } = item;

  const externalLink = path ? path.includes('http') : undefined;

  const hasChild = item.children && item.children.length > 0;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    if (nav.value) {
      nav.onFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isopen = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
   
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <NavItem
        item={item}
        offsetTop={offsetTop}
        open={nav.value}
        externalLink={externalLink}
        onClick={handleClick}
      />
      {hasChild && (
        <Portal>
          <Menu
            anchorEl={anchorEl}
            open={isopen}
            onClose={handleClose}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            PaperProps={{
              sx: {
                mt: 1,
                ml: 1,
                minWidth: 100,
                backgroundColor: 'white',
                borderRadius: 0,
                ...(nav.value && { mt: 0 }),
              },
            }}
          >
            {item.children?.map((child) => (
              <MenuItem key={child.title} onClick={handleClose} sx={{ width: '100%' }}>
                <Link href={child.path} target="_blank" underline="none" color="black" width="100%">
                  {child.title}
                </Link>
              </MenuItem>
            ))}
          </Menu>
        </Portal>
      )}
    </>
  );
}
